import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { defineComponent, computed } from 'vue';
import { iconNameOverrides, faIconPackByName } from '../../functions/configuration/icons.js';

var script = defineComponent({
    name: 'Icon',
    components: {
        FontAwesomeIcon,
    },
    props: {
        icon: {
            type: [String, Array],
            required: true,
        },
    },
    setup(props) {
        const computedIcon = computed(() => {
            var _a;
            let iconName = Array.isArray(props.icon) ? props.icon[1] : props.icon;
            if (!iconName) {
                console.error(`Missing icon name. Icon prop passed: ${props.icon}`);
                return null;
            }
            const overriddenName = iconNameOverrides[iconName];
            if (overriddenName) {
                iconName = overriddenName;
            }
            const iconPack = (_a = faIconPackByName[iconName]) !== null && _a !== void 0 ? _a : 'fasr';
            return [iconPack, iconName];
        });
        return {
            computedIcon,
        };
    },
});

export { script as default };
